/**
 * Helper utilities for table styling operations
 */

// Simple hash function to generate consistent class names from style objects
export function hashCode(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  return Math.abs(hash).toString(36);
}

// Helper function to convert attributes to use single quotes (saves space by avoiding &quot;)
export function convertToSingleQuoteAttributes(html: string): string {
  // Convert data-cell-styles="..." to data-cell-styles='...'
  html = html.replace(/data-cell-styles="([^"]*)"/g, (match, value) => {
    const decoded = value.replace(/&quot;/g, '"').replace(/&apos;/g, "'");
    return `data-cell-styles='${decoded}'`;
  });
  
  // Convert data-cell-settings="..." to data-cell-settings='...'
  html = html.replace(/data-cell-settings="([^"]*)"/g, (match, value) => {
    const decoded = value.replace(/&quot;/g, '"').replace(/&apos;/g, "'");
    return `data-cell-settings='${decoded}'`;
  });
  
  return html;
}

